<div class="container py-5">
  <div class="card p-4 access-denied-card">
    <h2 class="mb-2">{{ 'ERROR_MESSAGES.ACCESS_DENIED' | translate }}</h2>
    <p class="mb-4">{{ 'ERROR_MESSAGES.NO_PERMISSION' | translate }}</p>

    <div class="d-flex gap-2">
      <a class="btn btn-primary" [routerLink]="['/home']">Home</a>
      <a class="btn btn-outline-secondary" [routerLink]="['/login']">{{ 'LOGIN.TITLE' | translate }}</a>
    </div>
  </div>
</div>
